import { useContext } from 'react';
import { isLeftClick, isPlainClick } from '../../utils/clickHelpers';
import { DuperbrowseStreamContext } from '../DuperbrowseStreamContextProvider/DuperbrowseStreamContext';
import { getStreamItemId, getNormalizedStreamItemId } from '../redux/helpers';
import { useFlag } from '../../redux/flags/hooks/useFlag';
import { preloadFeature } from '../redux/constants';
import useDuperbrowseScrollRestoration from './useDuperbrowseScrollRestoration';
function useDuperbrowseLink(itemId, ref, onClick) {
    var hasPreloadFeature = useFlag(preloadFeature);
    var _a = useContext(DuperbrowseStreamContext), openDuperbrowse = _a.openDuperbrowse, loadDuperbrowse = _a.loadDuperbrowse, stream = _a.stream;
    useDuperbrowseScrollRestoration([itemId], ref);
    return function (e) {
        onClick && onClick(e);
        // only open duperbrowse if:
        // 1. our click wasn't canceled
        // 2. it's an unmodified left click
        // 3. it's actually inside the context stream
        if (!e.defaultPrevented &&
            isLeftClick(e) &&
            isPlainClick(e) &&
            stream.items.some(function (i) {
                return (hasPreloadFeature
                    ? getNormalizedStreamItemId(i)
                    : getStreamItemId(i)) === itemId;
            })) {
            e.preventDefault();
            hasPreloadFeature
                ? loadDuperbrowse(itemId, stream)
                : openDuperbrowse(itemId, stream);
        }
    };
}
export default useDuperbrowseLink;
//# sourceMappingURL=useDuperbrowseLink.js.map